'use strict';

var exports = (module.exports = {}),
    $ = require('dibs-jquery-shim'),
    _ = require('underscore');

/**
 * dibs.popUp - returns an object that can open a modal popup.
 *
 * Public Methods:
 *      open - opens the modal popup
 *      close - hides the modal popup, and removes it if removeAfterClose is true
 *      setCustomCss - takes an array of objects and sets the styles before opening
 *      getStatus - simple way to tell if modal popup is open or not
 *
 * @param inits {Mixed}
 *      Can be several things. 1: A string selector to use to find a dom element to use
 *      as the modal popup. 2: a jQuery instance to use as the dom element source.
 *      3: A hash with initial configuration options to use for the popup.
 * @param arg2 {Object}
 *      If inits is a string or instance of jQuery, then arg2 can be used to provide settings
 *      for the resulting object
 * @return {Object}
 */
exports.popUp = function(inits, arg2) {
    //initialize public and private namespace objects
    var pub = {},
        priv = {
            status: 1,
            // We don't set a width, but that can be done if the user wants to pass it in the inits object
            width: 'auto',
            height: 'auto',
            // The identifier is used to find an existing popUp or when a new one is created. If you are worried
            // that the identifier below will conflict with another DOM element, then change it here
            identifier: '#dibs-popup-frame',
            // Default class attribute attached to the DOM elements if they are created, or looked for if existing
            // elements are found.
            popupClass: 'dibs-popup',
            // The source html, file, or identifier to create or select the DOM element to use as our popup
            src: false,
            // If you want
            srcType: 'markup',
            customCss: false,
            fade: { status: true, duration: 700 },
            closeFade: { status: true, duration: 500 },
            overlayId: 'dibs-popup-overlay',
            closeBtn: 'dibs-close-btn',
            afterPopupClose: false,
            afterPopupOpen: false,
            contentWrapperId: 'dibs-popup-inner',
            useFrame: true, // If you want to use entirely your own html for the dialog, set this to false
            frameClass: 'dibs-popup rounded shadow', // Extra classes to add to the frame (if you are using it)
            removeAfterClose: true,
            selector: 'body', // Change this if you don't want to append the modal to the body
        };

    if (typeof inits === 'string' || inits instanceof $ === true) {
        priv.src = inits;
        if ($.isPlainObject(arg2)) {
            priv = _.extend(priv, arg2);
        }
    } else {
        priv = _.extend(priv, inits);
    }

    //applies css found in the priv.css array
    priv.applyCustomCss = function() {
        if (priv.customCss || priv.customCss.length > 0) {
            var i, iden, css;

            for (i = 0; i < priv.customCss.length; i += 1) {
                iden = priv.customCss[i].identifier;
                css = priv.customCss[i].css;

                $(iden).css(css);
            }
        }
    };

    //base frame for popup, for simplicity and standardization
    priv.getPopupFrame = function() {
        if (priv.frameClass.length === 0) {
            priv.frameClass = priv.popupClass;
        }

        var frame = $('<div>').attr({
            class: priv.frameClass,
            id: 'dibs-popup-frame',
        });

        $(
            '<span class="close" style="margin-top:-10px;" id="' + priv.closeBtn + '">&times</span>'
        ).appendTo(frame);
        $('<div>')
            .attr({ id: priv.contentWrapperId })
            .appendTo(frame);

        return frame;
    };

    //sets the jquery object for the popup
    priv.setPopup = function($popUp) {
        priv.$popUp = $popUp;
        return pub;
    };

    //finds and existing popup object if it exists
    pub.getPopup = function(useIdentifier) {
        if (priv.$popUp) {
            return priv.$popUp;
        }
        if (useIdentifier === true) {
            return $(priv.identifier);
        }
        return false;
    };

    // Set the overlay for this object, so that calling open wont
    // override the existing element
    priv.setOverlay = function($overlay) {
        priv.$overlay = $overlay;
        return pub;
    };

    // Get the overlay if it exists already
    priv.getOverlay = function() {
        if (priv.$overlay) {
            return priv.$overlay;
        }
        return false;
    };

    //centers the popup window based on your current screen
    priv.center = function() {
        var $popup = pub.getPopup(true),
            windowWidth = $(window).width(),
            windowHeight = $(window).height(),
            popupHeight = $popup.height(),
            popupWidth = $popup.width(),
            top = $(window).scrollTop() + (windowHeight - popupHeight) / 2; // - (windowHeight * 0.05)));

        $popup.css({
            position: 'absolute',
            top: top,
            left: windowWidth / 2 - popupWidth / 2,
        });
    };

    //set's the status var of the popup
    priv.setStatus = function(status) {
        priv.status = status;
        return pub;
    };

    //if the srcType property is a file, then this function runs when the src file is loaded
    priv.fileLoadCompleteHelper = function(src) {
        pub.setSrc(src);
        if ($('#' + priv.overlayId).length > 0) {
            priv.srcType = 'markup';
            pub.open();
        }
    };

    //tests if the funs a function attached as a callback for the close event of the popup
    priv.callAfterPopupClose = function() {
        if (priv.afterPopupClose && typeof priv.afterPopupClose === 'function') {
            priv.afterPopupClose.call(pub.getPopup());
        }
    };

    pub.resize = function(newWidth, newHeight, animate) {
        var css = {};
        if (newHeight) {
            css['height'] = newHeight;
        }
        if (newWidth) {
            css['width'] = newWidth;
            css['maxWidth'] = newWidth;
        }
        pub.getPopup().css(css);
        priv.center();
    };

    //sets the close btn identifier
    pub.setCloseBtn = function(btn) {
        priv.closeBtn = btn;
        return pub;
    };

    //retrieve status property
    pub.getStatus = function() {
        return priv.status;
    };

    //sets an object that will apply css to an identifier when the popup is created
    pub.setCustomCss = function(css, identifier) {
        if (priv.customCss === false) {
            priv.customCss = [];
        }
        priv.customCss.push({ identifier: identifier, css: css });

        return pub;
    };

    //sets src property
    pub.setSrc = function(src) {
        priv.src = src || false;
        return pub;
    };

    //opens popup
    pub.open = function() {
        var $overlay, $popup, $tmp;

        $(priv.identifier).hide(); // Make sure popup's display is set to none

        // if the overlay div doesn't exist, create it. We don't want keep deleting
        // and recreating the Overlay and the popup element
        if ($('#' + priv.overlayId).length === 0) {
            $(priv.selector).append('<div id="' + priv.overlayId + '" />');
        }

        // set default css for overlay. It needs to cover the entire window
        // and be invisible when it is first created so we can animate it later.
        $overlay = $('#' + priv.overlayId)
            .css({
                width: '100%',
                height: '100%',
                backgroundColor: '#222',
                display: 'none',
                opacity: 0,
                left: 0,
                top: 0,
                'z-index': 45,
                position: 'fixed',
            })
            .hide();

        // test if the identifier element doesn't exist
        // have to create new jQuery object in case other scripts
        // modify popup. If dibs.popUp was already used, we can load
        // Use that popup again.
        $tmp = $(priv.identifier);
        if ($tmp.length === 0) {
            //if src is set
            if (priv.src) {
                //if srcType is a file
                if (priv.srcType === 'file') {
                    //load file and set helper (which will continue opening the popup), end function
                    $.get(priv.src, priv.fileLoadCompleteHelper);
                    return; // Leave the script to wait until the file has completed loading asynchronously
                }

                //assuming src is markup, inserting markup after overlay div
                if (typeof priv.src === 'string') {
                    $popup = $('<div>')
                        .html(priv.src)
                        .children()
                        .first();
                    // if the src is an instance of jquery, then it's a dom element that we can just use
                } else if (priv.src instanceof $ === true) {
                    $popup = priv.src;
                }
            } else {
                throw new Error(
                    'No source code or existing page element was found to use for popup.'
                );
            }

            // If the user wants to use a base frame div with a close button for their popup
            if (priv.useFrame) {
                $popup = priv
                    .getPopupFrame()
                    .children('#' + priv.contentWrapperId)
                    .append($popup)
                    .parent();
            }
        } else {
            // the popup frame was already found.
            $popup = $tmp;
        }

        $popup
            .css({
                width: priv.width,
                height: priv.height,
                position: 'absolute',
                'z-index': 50,
                opacity: 0,
            })
            .hide();

        $overlay.after($popup).addClass(priv.popupClass);

        if (!priv.useFrame) {
            $popup.addClass(priv.popupClass);
        }

        //apply all custom css set in the customCss property
        priv.applyCustomCss();

        //center the popup
        priv.center();

        //center the popup any time the window resizes;
        $(window).on('resize scroll', function() {
            priv.center();
        });

        //show popup
        if (priv.fade.status === true) {
            $overlay.show().animate({ opacity: 0.7 }, priv.fade.duration * 0.6, function() {
                var $contentWrapper = $('#' + priv.contentWrapperId).css({ opacity: 0 });
                $popup.show().animate({ opacity: 1.0 }, priv.fade.duration * 0.4, function() {
                    $contentWrapper.animate({ opacity: 1.0 }, priv.fade.duration * 0.2, function() {
                        if (typeof priv.afterPopupOpen === 'function') {
                            priv.afterPopupOpen.call($popup);
                        }
                    });
                });
            });
        } else {
            $overlay.css({ opacity: 0.7, display: 'block' });
            $popup.show();
        }

        $overlay.on('click', pub.close);

        $popup.find('#' + priv.closeBtn).on('click', pub.close);

        //set the class jquery object for the popup and overlay
        priv.setPopup($popup);
        priv.setOverlay($overlay);

        priv.setStatus(1);

        return pub;
    };

    //close popup
    pub.close = function(after) {
        var $popup = pub.getPopup(),
            $overlay = priv.getOverlay(),
            duration,
            $contentWrapper;

        if (priv.closeFade.status === true) {
            duration = priv.closeFade.duration * 0.33;
            $contentWrapper = $popup.find('#' + priv.contentWrapperId);

            if ($contentWrapper.length > 0) {
                $contentWrapper.animate({ opacity: 0 }, duration, function() {
                    $popup.animate({ opacity: 0 }, duration, function() {
                        $overlay.animate({ opacity: 0 }, duration, function() {
                            $popup.hide();
                            $overlay.hide();
                            if (typeof priv.afterPopupClose === 'function') {
                                priv.afterPopupClose.call($popup);
                            }
                            if (typeof after === 'function') {
                                after.call($popup);
                            }
                            if (priv.removeAfterClose) {
                                $popup.remove();
                            }
                        });
                    });
                });
            } else {
                $popup.hide();
                $overlay.hide();
                priv.afterPopupClose.call($popup);
                if (priv.removeAfterClose) {
                    $popup.remove();
                }
            }
        } else {
            $popup.hide();
            $overlay.hide();
            priv.callAfterPopupClose();
            if (priv.removeAfterClose) {
                $popup.remove();
            }
        }

        priv.setStatus(0);
    };

    return pub;
};

/**
 * Uses dibs.popUp to create a model dialog with a yes and
 * no button. No will just close the popup, and the yes
 * button runs a function passed as a parameter.
 * @param heading {String}
 * @param message {String}
 * @param onYes {function}
 * @param onYesArgs {Array}
 * @param options {object} - an object with the text for buttons. Must have the attributes 'cancel' and 'confirm'
 */
exports.confirmDialog = function(heading, message, onYes, onYesArgs, options) {
    options = options || {};
    heading = heading ? '<p><strong>' + heading + '</strong></p>' : '';
    message = message ? '<p>' + message + '</p>' : '';

    var button1, button2;
    if (options) {
        button1 = options.cancel || 'No';
        button2 = options.confirm || 'Yes';
    } else {
        button1 = 'No';
        button2 = 'Yes';
    }

    var src =
        heading +
        message +
        '<div class="confirm-buttons pull-right">' +
        '<span class="dibs-confirm-no btn btn-default"><i class="fa fa-ban"></i> ' +
        button1 +
        '</span>&nbsp;' +
        '<span class="dibs-confirm-yes btn btn-primary"><i class="fa fa-check-circle fa-inverse"></i> ' +
        button2 +
        '</span>' +
        '</div> ';

    var clickedYes = false;

    var popup = exports
        .popUp($(src), {
            afterPopupOpen: function() {
                $(this)
                    .find('.dibs-confirm-yes')
                    .on('click', function() {
                        clickedYes = true;
                        popup.close(function() {
                            if (!_.isArray(onYesArgs)) {
                                onYesArgs = [onYesArgs];
                            }
                            onYes.apply(options.context, onYesArgs);
                        });
                    });
                $(this)
                    .find('.dibs-confirm-no')
                    .on('click', function() {
                        if (options.onCancel) {
                            options.onCancel.call(options.context);
                        }
                        popup.close();
                    });
            },
            afterPopupClose: function() {
                if (options.onCancel && !clickedYes) {
                    options.onCancel.call(options.context);
                }
            },
        })
        .open();
};

/**
 * Creates a modal dialog with an 'OK' button. Options allow you to
 * customize the button text, and add callbacks. You can also make
 * the dialog an alert.
 *
 * @param heading {String}
 * @param message {String}
 * @param options {Object}
 */
exports.infoModal = function(heading, message, options) {
    options = _.extend(
        {
            alert: false,
            addClass: false,
            okButton: true,
            onOk: false,
            buttonText: 'OK',
            buttonClass: 'btn-default',
            width: 'auto',
            maxWidth: 450,
        },
        options
    );

    var modal,
        modalOptions = { width: options.width, afterPopupClose: options.afterPopupClose },
        $wrap = $('<div class="info-wrapper">')
            .css('max-width', options.maxWidth)
            .append(),
        $message = $('<div>'),
        $okButton;

    if (options.alert) {
        modalOptions.frameClass = 'info-modal alert alert-group alert-' + options.alert;
    }

    if (options.addClass) {
        $wrap.addClass(options.addClass);
    }

    if (heading) {
        $wrap.append('<p><strong>' + heading + '</strong></p>');
    }

    $message.html('<div class="message-wrapper">' + message + '</div>').appendTo($wrap);

    if (options.okButton) {
        $okButton = $(
            '<div class="form-group">' +
                '<div class="btn ' +
                options.buttonClass +
                '">' +
                options.buttonText +
                '</div>' +
                '</div>'
        ).appendTo($wrap);

        $okButton.on('click', function() {
            if (typeof options.onOk === 'function') {
                options.onOk.call($okButton, modal);
            }
            modal.close();
        });
    }

    modal = exports.popUp($wrap, modalOptions).open();

    return modal;
};
